import { atom } from "jotai";
import { atomFamily } from "jotai-family";

import type { EventMemberDetail } from "@/lib/schemas";

import { supabase } from "@/lib/supabase";

export const eventMembersFamily = atomFamily((_eventId: string) =>
  atom<EventMemberDetail[]>([]),
);

export async function demoteMemberFromAdmin(
  eventId: string,
  userId: string,
): Promise<boolean> {
  try {
    const { error } = await supabase
      .from("event_member")
      .update({ role: "attendee" })
      .eq("event_id", eventId)
      .eq("user_id", userId);

    if (error) {
      console.error("demoteMemberFromAdmin error", error);
      return false;
    }
    return true;
  } catch (e) {
    console.error("demoteMemberFromAdmin error", e);
    return false;
  }
}

export async function promoteMemberToAdmin(
  eventId: string,
  userId: string,
): Promise<boolean> {
  try {
    const { error } = await supabase
      .from("event_member")
      .update({ role: "admin" })
      .eq("event_id", eventId)
      .eq("user_id", userId);

    if (error) {
      console.error("promoteMemberToAdmin error", error);
      return false;
    }
    return true;
  } catch (e) {
    console.error("promoteMemberToAdmin error", e);
    return false;
  }
}
